import { useQuery } from '@tanstack/react-query'

import { StaleTime } from '@core/query'
import { FollowQueryKey } from '../helpers/queryKeys'

import { createUsernameBatcher } from '../helpers/createUsernameBatcher'
import { followCheck } from '../services/followCheck'

const checkFollowing = createUsernameBatcher<boolean>(ids => followCheck(ids))

/**
 * Whether the current viewer follows `username` — batched across callers, see
 * {@link createUsernameBatcher}. Disabled for guests: they never follow anyone, so it would 401.
 */
export const useFollowCheck = (username: string, enabled = true) => {
    return useQuery({
        queryKey: FollowQueryKey.followCheck(username),
        queryFn: async () => (await checkFollowing(username)) ?? false,
        enabled: enabled && Boolean(username),
        staleTime: StaleTime.Short,
    })
}
